/**
 * 工具方法类
 */

import $ from 'jquery'
import mc from '@/components/common/mc-lib'

/**
 * 显示错误提示文字
 * @version 1.0
 * @param {string} msg 提示文字
 */
export const showError = function (msg) {
  if (msg.length > 100) {
    msg = '系统错误, 请稍后重试'
  }
  this.$message.error(msg)
}

/**
 * 获得纯净的数据模型
 * @version 1.0
 * @param {object} obj 待处理对象
 */
export const getModel = obj => JSON.parse(JSON.stringify(obj))

/**
 * 合并新数据到默认数据
 * @version 1.0
 * @param {*} defaultData 默认数据
 * @param {*} newData 新数据
 */
export const extendData = (defaultData, newData) => $.extend(true, defaultData, getModel(newData))

/**
 * 创建数据仓库
 * @version 1.0
 * @param {object} defaultData 默认数据
 */
export const createDataStore = defaultData => {
  class Store {
    data = defaultData
    getDefaultData = () => $.extend(true, {}, typeof this.data === 'function' ? this.data() : this.data)
    setDefaultData(data) {
      this.data = data
    }
  }
  return new Store()
}

/**
 * 常用请求
 * @version 1.5
 * @param {boolean} hasLoading 是否有请求Loading
 * @param {string} url 请求地址
 * @param {object} data 请求数据
 */
export const commonAjax = function (hasLoading, url = '', data = {}, hasFailTip = true) {
  let _hasLoading, _loadingType
  if (typeof hasLoading === 'boolean') {
    _hasLoading = !!hasLoading
    _loadingType = 1
  } else if (typeof hasLoading === 'number') {
    _hasLoading = true
    _loadingType = hasLoading
  }
  let _this = this
  return mc.Ajax({
    url: url,
    data: data,
    hasLoading: _hasLoading,
    loadingType: _loadingType,
    fail(response) {
      hasFailTip && showError.call(_this, response.description)
    },
    error() {
      hasFailTip && showError.call(_this, '网络错误, 请稍后重试')
    }
  })
}

/**
 * 常用表格数据获取函数
 * @param {object} option 配置项
 */
export const commonTableDateFetch = (option) => function (pageIndex) {
  let _this = this
  this.table.isLoading = true
  return mc.Ajax({
    url: option.url,
    data: $.extend({
      pageIndex: pageIndex || 1,
      pageSize: this.table.pageSize
    }, this.table && this.table.ajaxData, option.data && option.data.call(_this)),
    success(response) {
      option.success && option.success.call(_this, response)
      _this.table.currentPage = pageIndex
      _this.table.pageTotal = response.total
      _this.table.isLoading = false
    },
    fail(response) {
      option.fail && option.fail.call(_this, response)
      showError.call(_this, response.description)
      _this.table.isLoading = false
    }
  })
}

export const mvcParamMatch = (function () {
  var MvcParameterAdaptive = {}
  // 验证是否为数组
  MvcParameterAdaptive.isArray = Function.isArray || function (o) {
    return typeof o === 'object' &&
      Object.prototype.toString.call(o) === '[object Array]'
  }

  // 将数组转换为对象
  MvcParameterAdaptive.convertArrayToObject = function (arrName, array, saveOjb) {
    var obj = saveOjb || {}

    function func(name, arr) {
      for (var i in arr) {
        if (!MvcParameterAdaptive.isArray(arr[i]) && typeof arr[i] === 'object') {
          for (var j in arr[i]) {
            if (MvcParameterAdaptive.isArray(arr[i][j])) {
              func(name + '[' + i + '].' + j, arr[i][j])
            } else if (typeof arr[i][j] === 'object') {
              MvcParameterAdaptive.convertObject(name + '[' + i + '].' + j + '.', arr[i][j], obj)
            } else {
              obj[name + '[' + i + '].' + j] = arr[i][j]
            }
          }
        } else {
          obj[name + '[' + i + ']'] = arr[i]
        }
      }
    }

    func(arrName, array)

    return obj
  }

  MvcParameterAdaptive.convertObject = function (objName, turnObj, saveOjb) {
    var obj = saveOjb || {}

    function func(name, tobj) {
      for (var i in tobj) {
        if (MvcParameterAdaptive.isArray(tobj[i])) {
          MvcParameterAdaptive.convertArrayToObject(i, tobj[i], obj)
        } else if (typeof tobj[i] === 'object') {
          func(name + i + '.', tobj[i])
        } else {
          obj[name + i] = tobj[i]
        }
      }
    }

    func(objName, turnObj)
    return obj
  }

  return function (json, arrName) {
    arrName = arrName || ''
    if (typeof json !== 'object') throw new Error('请传入json对象')
    if (MvcParameterAdaptive.isArray(json) && !arrName) throw new Error('请指定数组名，对应Action中数组参数名称！')

    if (MvcParameterAdaptive.isArray(json)) {
      return MvcParameterAdaptive.convertArrayToObject(arrName, json)
    }
    return MvcParameterAdaptive.convertObject('', json)
  }
})()

export default {
  getModel: getModel,
  extendData: extendData,
  createDataStore: createDataStore,
  commonAjax: commonAjax,
  commonTableDateFetch: commonTableDateFetch,
  mvcParamMatch: mvcParamMatch
}



// WEBPACK FOOTER //
// ./src/components/common/tools.js